import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const Methodologie = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-5xl font-serif font-bold text-[#1a1a1a] mb-8 text-center">
            Méthodologie & indépendance
          </h1>

          <div className="prose prose-lg max-w-none">
            <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl mb-12 border border-gray-100">
              <p className="text-xl text-gray-700 leading-relaxed mb-0">
                La crédibilité de Giletau repose sur une méthodologie rigoureuse et une indépendance totale. Voici comment nous travaillons.
              </p>
            </div>

            <h2 className="text-3xl font-serif font-bold text-[#1a1a1a] mt-12 mb-6">
              Notre méthodologie documentaire
            </h2>

            <div className="space-y-8 mb-12">
              <div className="bg-white p-6 rounded-xl border border-gray-200">
                <h3 className="text-xl font-bold text-[#1a1a1a] mb-3 flex items-center gap-3">
                  <span className="bg-[#1a1a1a] text-white w-8 h-8 flex items-center justify-center rounded-lg text-sm flex-shrink-0">1</span>
                  Collecte et vérification des sources
                </h3>
                <p className="text-gray-700 leading-relaxed mb-0">
                  Nous croisons systématiquement plusieurs sources d'information : témoignages directs, documents officiels, archives médiatiques, publications académiques et données publiques. Chaque fait mentionné est vérifié et sourcé.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl border border-gray-200">
                <h3 className="text-xl font-bold text-[#1a1a1a] mb-3 flex items-center gap-3">
                  <span className="bg-[#1a1a1a] text-white w-8 h-8 flex items-center justify-center rounded-lg text-sm flex-shrink-0">2</span>
                  Contextualisation historique et sociale
                </h3>
                <p className="text-gray-700 leading-relaxed mb-0">
                  Chaque mouvement est replacé dans son contexte historique, social et politique. Nous analysons les causes profondes, les précédents historiques et les dynamiques sociétales à l'œuvre.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl border border-gray-200">
                <h3 className="text-xl font-bold text-[#1a1a1a] mb-3 flex items-center gap-3">
                  <span className="bg-[#1a1a1a] text-white w-8 h-8 flex items-center justify-center rounded-lg text-sm flex-shrink-0">3</span>
                  Écoute pluraliste des acteurs
                </h3>
                <p className="text-gray-700 leading-relaxed mb-0">
                  Nous donnons la parole aux différents acteurs impliqués : manifestants, organisateurs, observateurs, institutions, experts. Cette approche pluraliste garantit une vision équilibrée des événements.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl border border-gray-200">
                <h3 className="text-xl font-bold text-[#1a1a1a] mb-3 flex items-center gap-3">
                  <span className="bg-[#1a1a1a] text-white w-8 h-8 flex items-center justify-center rounded-lg text-sm flex-shrink-0">4</span>
                  Analyse et mise en perspective
                </h3>
                <p className="text-gray-700 leading-relaxed mb-0">
                  Au-delà de la simple description, nous analysons les mécanismes de mobilisation, les revendications, les stratégies d'action et les impacts sociétaux. Nous mettons en perspective les événements avec des analyses de fond.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl border border-gray-200">
                <h3 className="text-xl font-bold text-[#1a1a1a] mb-3 flex items-center gap-3">
                  <span className="bg-[#1a1a1a] text-white w-8 h-8 flex items-center justify-center rounded-lg text-sm flex-shrink-0">5</span>
                  Mise à jour continue
                </h3>
                <p className="text-gray-700 leading-relaxed mb-0">
                  Les mouvements sociaux évoluent rapidement. Nous mettons à jour nos articles régulièrement pour refléter les développements récents et corriger toute information obsolète ou inexacte.
                </p>
              </div>
            </div>

            <h2 className="text-3xl font-serif font-bold text-[#1a1a1a] mt-12 mb-6">
              Notre indépendance
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              L'indépendance de Giletau est absolue et non négociable :
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-3 mb-6">
              <li><strong>Aucune affiliation politique :</strong> Giletau n'est lié à aucun parti, mouvement ou organisation politique</li>
              <li><strong>Aucun financement partisan :</strong> Nous ne recevons aucun financement de partis politiques, syndicats ou groupes d'intérêt</li>
              <li><strong>Aucune influence économique :</strong> Notre contenu n'est pas influencé par des annonceurs ou des sponsors</li>
              <li><strong>Transparence totale :</strong> Nos sources de financement et notre méthodologie sont publiques</li>
            </ul>

            <h2 className="text-3xl font-serif font-bold text-[#1a1a1a] mt-12 mb-6">
              Nos sources d'information
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Nous nous appuyons sur une diversité de sources pour garantir la fiabilité de nos analyses :
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-3 mb-6">
              <li>Témoignages directs d'acteurs de terrain et de participants</li>
              <li>Documents officiels et archives publiques</li>
              <li>Publications académiques et recherches en sciences sociales</li>
              <li>Médias nationaux et internationaux (avec vérification croisée)</li>
              <li>Rapports d'organisations de la société civile</li>
              <li>Données statistiques et enquêtes d'opinion</li>
            </ul>

            <h2 className="text-3xl font-serif font-bold text-[#1a1a1a] mt-12 mb-6">
              Correction et transparence
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Malgré notre rigueur, des erreurs peuvent survenir. Nous nous engageons à :
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-3 mb-6">
              <li>Corriger rapidement toute information inexacte signalée</li>
              <li>Indiquer clairement les corrections apportées aux articles</li>
              <li>Accepter les retours et critiques constructives</li>
              <li>Maintenir un dialogue ouvert avec nos lecteurs</li>
            </ul>

            <div className="bg-[#1a1a1a] text-white p-8 rounded-2xl mt-12">
              <h3 className="text-2xl font-bold mb-4">
                Contactez-nous
              </h3>
              <p className="text-gray-200 leading-relaxed mb-4">
                Vous avez des questions sur notre méthodologie ? Vous souhaitez signaler une erreur ou proposer une source ? Contactez-nous à :
              </p>
              <p className="text-white font-semibold mb-0">
                <i className="ri-mail-line mr-2"></i>
                contact@giletau.fr
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Methodologie;
